<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.queues.ring-strategy-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <form>
        <div class="vox-input-group">
          <label translate>company.queues.ring-strategy-popup.label</label>
          <div ngbDropdown class="vox-dropdown-input">
            <button id="queue module" ngbDropdownToggle>
              <span>{{ 'company.queues.ring-strategy-popup.options.' + currentRingStrategy.toLowerCase() + '.label' | translate }}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="queue module">
              <button ngbDropdownItem *ngFor="let ring of ringStrategy" (click)="currentRingStrategy = ring;" >
                {{ 'company.queues.ring-strategy-popup.options.' + ring.toLowerCase() + '.label' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="vox-paragraph">{{ 'company.queues.ring-strategy-popup.options.' + currentRingStrategy.toLowerCase() + '.description' | translate }}</div>
        <button class="vox-btn vox-btn-secondary" type="submit" [ladda]="loading" (click)="saveModule()">
          <span translate>common.save</span>
        </button>
      </form>
    </div>
  </div>
</div>